import { Button, Card, DisclosureSummary, Text } from "@/components/ui"
import { useState } from "react"

type PrizeCodeDisclosureProps = {
  code: string
  tone: "game" | "store"
}

const LOOK = {
  game: { summary: "game", box: "game", copy: "game" },
  store: { summary: "neutral", box: "neutral", copy: "primary" },
} as const

/** The prize code behind a quiet "Ver código", for ordering by WhatsApp or at the counter; the app applies it on its own. */
export function PrizeCodeDisclosure({ code, tone }: PrizeCodeDisclosureProps) {
  const [copied, setCopied] = useState(false)
  const look = LOOK[tone]

  async function copy() {
    try {
      await navigator.clipboard.writeText(code)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <details className="group">
      <DisclosureSummary tone={look.summary} className="mx-auto">
        <span className="group-open:hidden">Ver código</span>
        <span className="hidden group-open:inline">Esconder código</span>
      </DisclosureSummary>
      <div className="mt-2 flex flex-col gap-1.5">
        <Card variant="stub" tone={look.box} padding="compact" className="flex items-center justify-between gap-3">
          <Text as="strong" size="sm" weight="bold" tracking="wide" className="select-all">
            {code}
          </Text>
          <Button variant="text" tone={look.copy} size="auto" onClick={() => void copy()}>
            <Text as="span" size="sm">
              {copied ? "Copiado" : "Copiar"}
            </Text>
          </Button>
        </Card>
        <Text size="xs" tone="muted">
          Para pedir pelo WhatsApp ou no balcão. No app, o prêmio entra sozinho.
        </Text>
        <span role="status" aria-live="polite" className="sr-only">
          {copied ? "Código copiado" : ""}
        </span>
      </div>
    </details>
  )
}
